<template>
  <main class="tissue-test-single">
    <MetaHead/>
    <TestDetails/>
    <CropInfo/>
    <TestResult v-if="interpretations.length"/>
    <InterpretationChart v-if="interpretations.length"/>
  </main>
</template>

<script>
import TestDetails from '@/components/tests/tissue/TestDetails'
import TestResult from '@/components/tests/tissue/TestResult'
import CropInfo from '@/components/tests/tissue/CropInfo'
import MetaHead from '@/components/tests/tissue/MetaHead'
import InterpretationChart from '@/components/tests/tissue/InterpretationChart'
import { TestAPI } from '@/api';
import { mapGetters } from 'vuex';

export default {
  components: {
    TestDetails,
    CropInfo,
    TestResult,
    MetaHead,
    InterpretationChart,
  },
  methods: {
    sync(route) {
      this.$store.dispatch('tests/tissue/getSingle', route.params.test);
    },
    isCreating(route) {
      if(/new/.test(route.name)) {
        this.$store.commit('tests/tissue/clearForm');
        this.$store.commit('tests/tissue/setCreateMode', true);
        this.$store.dispatch('tests/tissue/initDefaultData');
      } else {
        this.$store.commit('tests/tissue/setCreateMode', false);
        this.sync(route);
      }
    }
  },
  created() {
    this.isCreating(this.$route);
  },
  watch: {
    $route(to) {
      this.isCreating(to)
    }
  },
  computed: {
    ...mapGetters({
      interpretations: 'tests/tissue/interpretations'
    })
  }
}
</script>

<style lang="scss" scoped>

.tissue-test-single {
  .test-details {
    
  }
  .crop-info {
    margin-top: 8px;
  }
  .test-result {
    margin-top: 8px;
  }
}

</style>